import { css } from '@emotion/react';
import { PureComponent } from 'react';

import Player from 'my-components/VideoPlayer';

export default class VideoBlock extends PureComponent {
  render() {
    const { block, blockProps, contentState } = this.props;
    const data = contentState.getEntity(block.getEntityAt(0)).getData();
    const videoProps = blockProps.video;
    const autoPlay = !!videoProps?.autoPlay;
    const loop = !!videoProps?.loop;
    const defaultMuted = !!videoProps?.defaultMuted;
    switch (data.source) {
      case 'upload':
      case 'library':
        return (
          <div css={classes.wrapper}>
            <Player autoPlay={autoPlay} defaultMuted={defaultMuted} loop={loop} url={data.url} urls={data.urls} />
          </div>
        );
      case 'youtube':
        return (
          <div css={[classes.wrapper, classes.ytWrapper]}>
            <iframe // eslint-disable-line @eslint-react/dom/no-missing-iframe-sandbox
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              css={classes.ytVid}
              frameBorder="0"
              src={`https://www.youtube.com/embed/${data.youtubeId}${
                autoPlay || loop ?
                  `?${[
                    [autoPlay, 'autoplay'],
                    [loop, 'loop'],
                    [defaultMuted, 'mute'],
                  ]
                    .filter(([b]) => b)
                    .map(([, p]) => `${p}=1`)
                    .join('&')}`
                : ''
              }${loop && `&playlist=${data.youtubeId}`}`}
            />
          </div>
        );
    }
  }
}

const classes = {
  wrapper: css({
    width: '100%',
    maxWidth: '500px',
    margin: '0 auto',
  }),
  ytWrapper: css({
    position: 'relative',
    '&:before': {
      content: '""',
      display: 'block',
      width: '100%',
      height: 0,
      paddingBottom: '56.25%',
    },
  }),
  ytVid: css({
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
  }),
};
